import { css } from "@emotion/react";
import { AlertColor } from "@mui/lab/Alert";
import { defaultTheme } from "styles/defaultTheme";

/**
 * Mixin: get icon color based on severity
 *
 * @param severity
 */
export const iconColor = (severity: AlertColor = "info") => {
  switch (severity) {
    case "info":
      return css`
        color: ${defaultTheme.palette.objective.blue.main} !important;
      `;
    case "warning":
      return css`
        color: ${defaultTheme.palette.objective.yellow.main} !important;
      `;
    case "error":
      return css`
        color: ${defaultTheme.palette.objective.red.main} !important;
      `;
    case "success":
      return css`
        color: ${defaultTheme.palette.objective.green.main} !important;
      `;
    default:
      return css`
        color: ${defaultTheme.palette.objective.blue.main} !important;
      `;
  }
};
